import React from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Typography,
    withStyles,
    WithStyles
} from '@material-ui/core';
import styles from './styles';
import DialogTitle from "../../../components/Common/DialogTitle";

interface IProps extends WithStyles<typeof styles> {
    isOpen: boolean;
    handleClose: () => void;
    handleSubmit: () => void;
}

const WidgetEnable: React.FC<IProps> = ({
                                            classes,
                                            isOpen,
                                            handleClose,
                                            handleSubmit,
                                        }) => {

    return (
        <Dialog
            classes={{ paper: classes.paperEdit }}
            open={isOpen}
        >
            <DialogTitle onClose={handleClose}>
                Назначить шлюз основным?
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText className={classes.desc}>
                    <Typography variant="body1" color="textPrimary">
                        Вы уверены, что хотите назначить этот шлюз основным?
                    <Typography variant="body1" color="textPrimary">
                        Рекомендуем перед этим убедиться, что шлюз настроен корректно и в параметрах интеграции стоит статус “Подключено”.                    </Typography>
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.dialogActionsWrap}>
                <Button
                    className={classes.btnWrapClose}
                    variant="contained"
                    color="secondary"
                    onClick={handleClose}
                >
                    Отмена
                </Button>
                <Button
                    className={classes.btnWrapSuccess}
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Назначить этот шлюз
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(WidgetEnable);
